module.exports = __webpack_public_path__ + "img/signin_background.d5c54b79.png";